(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-display"] && !window.DesignMode) return;
  try {
    
  class CollectionProductsCarousel {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-carousel] .collection-products-display__carousel-track');
      this.prevButton = element.querySelector('[data-carousel-prev]');
      this.nextButton = element.querySelector('[data-carousel-next]');
      this.currentIndex = 0;
      this.itemWidth = 0;
      this.visibleItems = 0;
      this.isDragging = false;
      this.startPos = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationID = 0;
      
      this.init();
    }

    init() {
      if (!this.track) return;
      
      this.updateDimensions();
      this.bindEvents();
      this.updateButtons();
      this.setupTouchEvents();
    }

    updateDimensions() {
      const items = this.track.children;
      if (items.length === 0) return;
      
      this.itemWidth = items[0].offsetWidth;
      this.visibleItems = Math.floor(this.track.offsetWidth / this.itemWidth);
      this.prevTranslate = -this.currentIndex * this.itemWidth;
      this.setTransform(this.prevTranslate);
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      window.addEventListener('resize', () => {
        this.updateDimensions();
        this.goTo(this.currentIndex);
      });
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    goTo(index) {
      this.goToSlide(index);
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
        this.prevButton.style.opacity = this.currentIndex === 0 ? '0.5' : '1';
      }
      
      if (this.nextButton) {
        const maxIndex = this.track.children.length - this.visibleItems;
        this.nextButton.disabled = this.currentIndex >= maxIndex;
        this.nextButton.style.opacity = this.currentIndex >= maxIndex ? '0.5' : '1';
      }
    }

    setupTouchEvents() {
      this.track.addEventListener('touchstart', this.touchStart.bind(this), { passive: false });
      this.track.addEventListener('touchmove', this.touchMove.bind(this), { passive: false });
      this.track.addEventListener('touchend', this.touchEnd.bind(this), { passive: false });
    }

    touchStart(event) {
      this.isDragging = true;
      this.startPos = this.getPositionX(event);
      this.animationID = requestAnimationFrame(this.animation.bind(this));
      this.track.style.cursor = 'grabbing';
    }

    touchMove(event) {
      if (!this.isDragging) return;
      
      const currentPosition = this.getPositionX(event);
      const diff = currentPosition - this.startPos;
      const moveX = this.prevTranslate + diff;
      
      // Prevent scrolling when swiping
      if (Math.abs(diff) > 10) {
        event.preventDefault();
      }
      
      this.setTransform(moveX);
    }

    touchEnd() {
      this.isDragging = false;
      cancelAnimationFrame(this.animationID);
      
      const movedBy = this.currentTranslate - this.prevTranslate;
      
      // Determine if swipe was significant enough to change slide
      if (Math.abs(movedBy) > this.itemWidth * 0.3) {
        if (movedBy < 0 && this.currentIndex < this.getMaxIndex()) {
          this.next();
        } else if (movedBy > 0 && this.currentIndex > 0) {
          this.prev();
        } else {
          this.goToSlide(this.currentIndex);
        }
      } else {
        this.goToSlide(this.currentIndex);
      }
      
      this.track.style.cursor = 'grab';
    }

    getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    animation() {
      this.setTransform(this.currentTranslate);
    }

    setTransform(x) {
      this.currentTranslate = x;
      this.track.style.transform = `translateX(${x}px)`;
    }

    getMaxIndex() {
      return Math.max(0, this.track.children.length - this.visibleItems);
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.getMaxIndex()));
      this.prevTranslate = -this.currentIndex * this.itemWidth;
      this.setTransform(this.prevTranslate);
      this.updateButtons();
    }
  }

  // Initialize carousels when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(carousel => new CollectionProductsCarousel(carousel));
  });

  // Re-initialize carousels when sections are re-rendered
  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('[data-carousel]');
    if (carousel) {
      new CollectionProductsCarousel(carousel);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-backup"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-popup"]) return;
  try {
    
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  } else {
    expires = "; expires=0";
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

window.onload = function() {
  // Get the current date
  var currentDate = new Date();
  // var currentDate = new Date(2022, 11, 25);
  console.log(currentDate);
  
  // Set the threshold date to December 25th, 2022
  var thresholdDate = new Date(2022, 11, 25);
  console.log(thresholdDate);
  
  // Check if the current date is on or after the threshold date
  if (currentDate >= thresholdDate) {
    return;
  }

  // Check if the popup has already been shown this session
  if (getCookie('popupShown') === 'true') {
    return;
  }

  var popup = document.getElementById('popup-simple');
  popup.style.display = 'block';
  
  // Add an event listener to close the popup when clicking outside of it
  popup.addEventListener('click', function(event) {
    if (!event.target.closest('#popup-simple')) {
      popup.style.display = 'none';
    }
  });

  // Set a cookie to indicate that the popup has been shown this session
  setCookie('popupShown', 'true', 1);
};

document.getElementById('close-button').onclick = function() {
  document.getElementById('popup-simple').style.display = 'none';
}

  } catch(e) { console.error(e); }
})();
})();
